// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1zc1g","disabled":"FileBtn_disabled__QDLFP","warn":"FileBtn_warn__3F5zK","fade":"FileBtn_fade__2E11I"};